export default __webpack_public_path__ + "static/purchaseFlag-0388a3735ab87dc7acf1b843b3c50930.png";